<template>
  <div class="order-pay-container">
    <div class="main-content">
      <!-- 顶部提示 Banner -->
      <div class="status-banner">
        <div class="banner-left">
          <i class="el-icon-time banner-icon" />
          <span>秒杀锁单成功！请在 <strong>15 分钟</strong> 内完成支付，超时将自动释放库存</span>
        </div>
        <el-tag type="danger" size="small" effect="dark">订单号: {{ orderId }}</el-tag>
      </div>

      <el-card shadow="never" class="pay-card">
        <!-- 1. 收货地址 confirm -->
        <div class="section">
          <div class="section-title">
            <i class="el-icon-location-outline" /> 收货地址确认
          </div>
          <div class="address-box">
            <el-radio-group v-model="selectedAddressId">
              <el-radio :label="1" border class="address-radio">
                <span class="user-name">张三</span>
                <span class="user-phone">138****8888</span>
                <span class="address-detail">北京市朝阳区软件园 1 号楼 5 层</span>
                <el-tag size="mini" type="success" effect="plain" class="default-badge">默认</el-tag>
              </el-radio>
            </el-radio-group>
          </div>
        </div>

        <el-divider />

        <!-- 2. 商品明细 -->
        <div class="section">
          <div class="section-title">
            <i class="el-icon-goods" /> 抢购商品明细
          </div>
          <el-table :data="[goods]" border size="medium" class="goods-table">
            <el-table-column label="商品信息" min-width="200">
              <template slot-scope="scope">
                <div class="table-goods-cell">
                  <img :src="scope.row.picUrl || 'https://via.placeholder.com/50'" class="table-goods-img">
                  <span class="table-goods-title">{{ scope.row.title }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="seckillPrice" label="秒杀单价" width="130" align="center">
              <template slot-scope="scope">
                <span class="table-price">￥{{ scope.row.seckillPrice }}</span>
              </template>
            </el-table-column>
            <el-table-column label="数量" width="100" align="center">
              <template>1</template>
            </el-table-column>
            <el-table-column label="小计" width="140" align="center">
              <template slot-scope="scope">
                <span class="subtotal-price">￥{{ scope.row.seckillPrice }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 3. 操作栏 -->
        <div class="pay-action-bar">
          <div class="price-summary">
            <span class="summary-label">实付款：</span>
            <span class="currency">￥</span>
            <span class="price-num">{{ goods.seckillPrice }}</span>
          </div>
          <el-button
            type="success"
            size="medium"
            class="go-pay-btn"
            icon="el-icon-wallet"
            :loading="prepayLoading"
            @click="handleCreatePrepay"
          >
            立即支付
          </el-button>
        </div>
      </el-card>
    </div>

    <!-- 4. 收银台弹窗 (内嵌 iframe) -->
    <el-dialog
      title="收银台 - 微信安全支付"
      :visible.sync="payDialogVisible"
      width="480px"
      custom-class="pay-dialog"
      center
      :destroy-on-close="true"
      @close="handleDialogClose"
    >
      <div class="pay-container">
        <!-- 订单简要信息展示 -->
        <div class="pay-detail-bar">
          <span class="detail-item">订单号：<code>{{ orderId }}</code></span>
          <span class="detail-item price">应付金额：<strong>￥{{ goods.seckillPrice }}</strong></span>
        </div>

        <!-- iframe 内嵌第三方收银台页面 -->
        <div v-if="payUrl" v-loading="iframeLoading" class="iframe-wrapper">
          <iframe
            :src="payUrl"
            frameborder="0"
            width="100%"
            height="380px"
            scrolling="auto"
            @load="iframeLoading = false"
          />
        </div>
        <div v-else class="no-url-tip">
          <el-empty description="未获取到有效的支付页面地址" :image-size="100" />
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="payDialogVisible = false">遇到问题，稍后支付</el-button>
        <el-button type="success" size="small" icon="el-icon-check" :loading="checking" @click="checkPayResultManual">
          已完成支付
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getProductDetail, prePayOrder, getOrderDetail } from '@/api/mall'

export default {
  name: 'OrderPay',
  data() {
    return {
      userId: 0,
      orderId: '',
      skuId: null,
      selectedAddressId: 1,
      goods: {
        title: '加载中...',
        picUrl: '',
        seckillPrice: '0.00'
      },
      prepayLoading: false,
      prepayId: '',
      payUrl: '',
      payDialogVisible: false,
      iframeLoading: true,
      pollTimer: null,
      checking: false
    }
  },
  created() {
    const userInfo = this.$store.state.userInfo
    if (userInfo !== null) {
      this.userId = userInfo.userId
    }

    this.orderId = this.$route.query.orderId || ''
    this.skuId = this.$route.query.skuId || 1
    if (this.skuId) {
      this.getData()
    }
  },
  beforeDestroy() {
    this.stopPolling()
  },
  methods: {
    getData() {
      const queryParams = { orderId: this.orderId }
      getOrderDetail(queryParams).then(resp => {
        if (resp.code === 0) {
          if (resp.data.status === 'PAID') {
            this.$message.info('该订单已完成支付，正在跳转至订单列表...')
            this.$router.replace('/mall/order')
          } else {
            getProductDetail(this.skuId).then(pResp => {
              if (pResp.code === 0) {
                this.goods = pResp.data
              }
            })
          }
        } else {
          this.$message.warning(resp.msg)
        }
      })
    },
    async handleCreatePrepay() {
      this.prepayLoading = true
      try {
        const payload = {
          orderId: this.orderId,
          userId: this.userId,
          payType: 'WECHAT'
        }

        const resp = await prePayOrder(payload)
        if (resp.code === 0 && resp.data) {
          this.prepayId = resp.data.prepayId || ''
          const baseUrl = resp.data.payUrl || ''
          if (baseUrl) {
            this.payUrl = `${baseUrl}?prepayId=${this.prepayId}&orderId=${this.orderId}`
          } else {
            this.payUrl = ''
          }

          this.iframeLoading = true
          this.payDialogVisible = true
          this.startPolling()
        } else {
          this.$message.error(resp.msg || '创建预支付订单失败')
        }
      } catch (err) {
        this.$message.error('网络繁忙，无法连接支付网关')
      } finally {
        this.prepayLoading = false
      }
    },
    startPolling() {
      this.stopPolling()
      this.pollTimer = setInterval(async() => {
        try {
          const resp = await getOrderDetail({ orderId: this.orderId })
          if (resp.code === 0 && (resp.data.status === 'PAID' || resp.data.status === 1)) {
            this.handlePaySuccess()
          }
        } catch (e) {
          console.error('轮询查询订单状态失败', e)
        }
      }, 2000)
    },
    stopPolling() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer)
        this.pollTimer = null
      }
    },
    handlePaySuccess() {
      this.stopPolling()
      this.payDialogVisible = false
      this.$message.success('🎉 支付成功！系统正为您准备发货')
      setTimeout(() => {
        this.$router.push('/mall/order')
      }, 1000)
    },
    async checkPayResultManual() {
      this.checking = true
      try {
        const resp = await getOrderDetail({ orderId: this.orderId })
        if (resp.code === 0 && (resp.data.status === 'PAID' || resp.data.status === 1)) {
          this.handlePaySuccess()
        } else {
          this.$message.warning('暂未收到支付成功通知，请确认是否已扣款')
        }
      } catch (err) {
        this.$message.error('校验失败，请稍后再试')
      } finally {
        this.checking = false
      }
    },
    handleDialogClose() {
      this.stopPolling()
    }
  }
}
</script>

<style scoped>
.order-pay-container {
  min-height: 100vh;
  background-color: #f8fafc;
  padding: 24px 0;
}

.main-content {
  max-width: 860px;
  margin: 0 auto;
  padding: 0 16px;
}

.status-banner {
  background: linear-gradient(90deg, #fef2f2 0%, #fff 100%);
  border: 1px solid #fecaca;
  padding: 12px 20px;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  font-size: 13px;
  color: #991b1b;
}

.banner-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.banner-icon {
  font-size: 16px;
  color: #ef4444;
}

.pay-card {
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.section-title {
  font-size: 15px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.address-box {
  margin-bottom: 8px;
}

.address-radio {
  height: auto !important;
  padding: 12px 20px !important;
  border-radius: 6px !important;
}

.user-name {
  font-weight: bold;
  color: #0f172a;
  margin-right: 8px;
}

.user-phone {
  color: #475569;
  margin-right: 12px;
}

.address-detail {
  color: #64748b;
  margin-right: 12px;
}

.goods-table {
  border-radius: 6px;
  overflow: hidden;
}

.table-goods-cell {
  display: flex;
  align-items: center;
  gap: 12px;
}

.table-goods-img {
  width: 44px;
  height: 44px;
  border-radius: 4px;
  object-fit: cover;
  border: 1px solid #f1f5f9;
}

.table-goods-title {
  font-size: 13px;
  color: #334155;
  font-weight: 500;
}

.table-price {
  color: #475569;
}

.subtotal-price {
  color: #ef4444;
  font-weight: bold;
}

.pay-action-bar {
  margin-top: 24px;
  background-color: #f8fafc;
  padding: 16px 24px;
  border-radius: 8px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 20px;
}

.summary-label {
  font-size: 14px;
  color: #64748b;
}

.currency {
  color: #ef4444;
  font-weight: bold;
  font-size: 16px;
}

.price-num {
  font-size: 26px;
  color: #ef4444;
  font-weight: 800;
  font-family: Arial, sans-serif;
}

.go-pay-btn {
  background-color: #10b981;
  border-color: #10b981;
  font-weight: 600;
  padding: 10px 28px;
}

.go-pay-btn:hover {
  background-color: #059669;
  border-color: #059669;
}

.pay-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.pay-detail-bar {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 10px 16px;
  background-color: #f1f5f9;
  border-radius: 6px;
  margin-bottom: 14px;
  font-size: 13px;
  color: #475569;
  box-sizing: border-box;
}

.pay-detail-bar code {
  color: #0f172a;
}

.pay-detail-bar .price strong {
  color: #ef4444;
  font-size: 15px;
}

.iframe-wrapper {
  width: 100%;
  height: 380px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  overflow: hidden;
}

.no-url-tip {
  padding: 20px 0;
}
</style>
